"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _SttListItem = _interopRequireDefault(require("../SttList/SttListItem"));
var _SttListItemText = _interopRequireDefault(require("../SttList/SttListItemText"));
var _SttListItemIcon = _interopRequireDefault(require("./SttListItemIcon"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
var _SttHeading = _interopRequireDefault(require("../SttTypography/SttHeading"));
var _SttCollapse = _interopRequireDefault(require("../SttCollapse"));
var _excluded = ["options", "nested", "closeDrawer", "disabledItem"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: 'transparent'
    }
  };
});
var ItemLista = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      "&$selected": {
        backgroundColor: theme.palette.primary.main,
        color: "white"
      },
      "&$selected:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "white"
      }
    },
    selected: {}
  };
})(_SttListItem["default"]);
var renderList = function renderList(options) {
  var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var handleClick = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var nested = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var index = arguments.length > 4 ? arguments[4] : undefined;
  var closeDrawer = arguments.length > 5 ? arguments[5] : undefined;
  var disabledItem = arguments.length > 6 ? arguments[6] : undefined;
  var _ref = options.buttonProps || false,
    disabled = _ref.disabled,
    selected = _ref.selected;
  var expansion = checkExpansion(options);
  if (options.onClick) {
    handleClick = function handleClick() {
      options.onClick();
      if (closeDrawer) {
        closeDrawer();
      }
    };
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    key: options.id || options.key || index
  }, /*#__PURE__*/_react["default"].createElement(ItemLista, {
    button: options.button,
    disabled: disabled,
    selected: selected || open || expansion,
    onClick: handleClick,
    nested: nested
  }, options.icon ? /*#__PURE__*/_react["default"].createElement(_SttListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(options.icon, null)) : '', /*#__PURE__*/_react["default"].createElement(_SttListItemText["default"], {
    disableTypography: true,
    primary: /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h4"
    }, options.text),
    secondary: /*#__PURE__*/_react["default"].createElement(_SttText["default"], null, options.subtext)
  }), options.list ? open || expansion ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : ''), options.list ? /*#__PURE__*/_react["default"].createElement(_SttCollapse["default"], {
    "in": open || expansion,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(SttList, {
    options: options.list,
    nested: true,
    closeDrawer: closeDrawer,
    disabledItem: disabledItem
  })) : '');
};
var checkExpansion = function checkExpansion(options) {
  var expansion = false;
  if (options && options.list) {
    var list = options.list;
    list.forEach(function (element) {
      if (element.list) {
        expansion = checkExpansion(element);
      } else if (element.buttonProps && element.buttonProps.selected) {
        expansion = true;
      }
    });
  }
  return expansion;
};
var SttList = function SttList(props) {
  var classes = useStyles();
  var options = props.options,
    nested = props.nested,
    closeDrawer = props.closeDrawer,
    disabledItem = props.disabledItem,
    other = _objectWithoutProperties(props, _excluded);
  var nestedItems = options.filter(function (element) {
    return element.list;
  });
  var arr = new Array(nestedItems.length);
  var _useState = (0, _react.useState)(arr.fill(false)),
    _useState2 = _slicedToArray(_useState, 2),
    listOpen = _useState2[0],
    setOpen = _useState2[1];
  var handleClick = function handleClick(index) {
    if (!options[index].list) {
      disabledItem(options[index].id);
    }
    listOpen[index] = !listOpen[index];
    var arr2 = Object.assign([], listOpen);
    setOpen(arr2);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.List, _extends({
    component: "nav"
  }, other), options.map(function (option, index) {
    return renderList(option, listOpen[index], function () {
      return handleClick(index);
    }, nested, index, closeDrawer, disabledItem);
  })));
};
var _default = SttList;
exports["default"] = _default;